import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../api";

import { NotificationsLevel } from "../../../../../lib/enums";
import { show } from "../../../../../notifications/notifications";
import { SaveLayoutPayload } from "../@types";
import { LAYOUT_DETAILS_KEY } from "./useGetLayoutDetails";
import useNavigationBlockContext from "./useNavigationBlockContext";

const saveLayout = (payload: SaveLayoutPayload) => api.updateLayout(payload);

const useSaveLayout = () => {
  const queryClient = useQueryClient();

  const { api: blockApi } = useNavigationBlockContext();

  const { mutate } = useMutation({
    mutationFn: saveLayout,
    onMutate: () => {
      blockApi.reset();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LAYOUT_DETAILS_KEY] });
      show({
        level: NotificationsLevel.SUCCESS,
        message: "Changes have been successfully saved!"
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: `Failed to save layout!`
      });
    }
  });

  return { save: mutate };
};

export default useSaveLayout;
